import { render, staticRenderFns } from "./courseVideos.vue?vue&type=template&id=257697c6"
import script from "./courseVideos.vue?vue&type=script&lang=js"
export * from "./courseVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports